import React, { useContext, useEffect, useState } from 'react';
import { PeFilterContext } from '../../Contexts/PeFilterContext';
import MultiSelectEntity from '../RefineSearch/MultiSelectEntity';
import Popup from '../Common/Popup';

/**
 * The `CompanyTypeFilter` function is a React component that renders a filter for selecting company
 * types, with options for single or multiple selection.
 * @returns a JSX element.
 */
function CompanyTypeFilter({ setCompanyTypeOptions, CompanyTypeOptions, customPathname, isMulti, label = "Company Type", isPopupOpen, setIsPopupOpen }) {
    const { companyType, refineSearchFilters } = useContext(PeFilterContext);
    const [internalPopupOpen, setInternalPopupOpen] = useState(false);
    const popupOpen = isPopupOpen !== undefined ? isPopupOpen : internalPopupOpen;
    const setPopupOpen = setIsPopupOpen !== undefined ? setIsPopupOpen : setInternalPopupOpen;

    useEffect(() => {
        const companyTypeIds = refineSearchFilters[customPathname]?.companyType?.map(value => value.id) ?? [];
        setCompanyTypeOptions(companyType.map(type => ({ ...type, isChecked: companyTypeIds.includes(type.id) })));
    }, [companyType, customPathname, refineSearchFilters, setCompanyTypeOptions]);

    const handleCompanyTypeChange = (e) => {
        const { name, checked, id, filteredIds } = e.target;
        let updatedCompanyTypes;

        if (name === "allSelect") {
            updatedCompanyTypes = CompanyTypeOptions.map((type) => ({ ...type, isChecked: checked }));
        } else if (name === "filteredSelect" && filteredIds) {
            updatedCompanyTypes = CompanyTypeOptions.map((type) => {
                if (filteredIds.includes(type.id)) {
                    return { ...type, isChecked: checked };
                }
                return type;
            });
        } else {
            updatedCompanyTypes = CompanyTypeOptions.map(type =>
                type.id == id ? { ...type, isChecked: checked } : type
            );
        }
        setCompanyTypeOptions(updatedCompanyTypes);
    };

    const selectedCompanyTypeLength = CompanyTypeOptions?.filter(option => option.isChecked)?.length ?? 0;

    return (
        <div className="relative w-full md:inline-block">
            <button
                type="button"
                className="h-10 rounded-md px-4 py-1 text-gray-500 hover:bg-gray-100  text-sm shadow-md border border-gray-300 text-left flex items-center justify-between w-full md:w-[90%]"
                onClick={() => setPopupOpen(!popupOpen)}
            >
                <span className="truncate pr-2">{label} <span className="opacity-60 ml-2 text-xs text-ellipsis">e.g. {CompanyTypeOptions.slice(0,2).map(item => item.name).join(', ')}</span></span>
                <div className="flex items-center gap-2 flex-shrink-0">
                    {selectedCompanyTypeLength > 0 && (
                        <span className="bg-white rounded-full px-2 py-0.5 text-xs font-medium border border-gray-400">
                            {selectedCompanyTypeLength}
                        </span>
                    )}
                    <span className={`transition-transform duration-200 text-xl font-semibold ${popupOpen ? 'rotate-[270deg]' : 'rotate-90'}`}>
                        ›
                    </span>
                </div>
            </button>

            {popupOpen && (
                <Popup onClose={() => setPopupOpen(false)}>
                    <div className="p-4">
                        <MultiSelectEntity
                            handleEntityChange={handleCompanyTypeChange}
                            primaryEntity={CompanyTypeOptions}
                            showAll={false}
                        />
                    </div>
                </Popup>
            )}
        </div>
    );
}

export default CompanyTypeFilter;